export default __webpack_public_path__ + "static/media/roadmapV2BgMb.b244c4f1.png";